import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
  LOCALE_ID,
} from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { provideRouter } from '@angular/router';
import { provideHttpClient, HttpClientModule, withFetch, withInterceptors, HTTP_INTERCEPTORS } from '@angular/common/http';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideTranslateService,
  TranslateLoader,
  TranslateModule,
} from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { authInterceptor } from '@core/authentication/auth/auth.interceptor';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser'

import { provideFirebaseApp, initializeApp as initializeAppFire } from '@angular/fire/app';
import { provideFunctions, getFunctions, connectFunctionsEmulator } from '@angular/fire/functions';
import { environment } from '@envs/environment';

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (
  http: HttpClient
) => new TranslateHttpLoader(http, './i18n/', '.json');

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideClientHydration(withEventReplay()),
    provideAnimationsAsync(),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    provideFirebaseApp(() => initializeAppFire(environment.firebase)),
    provideFunctions(() => {
      const functions = getFunctions();
      // if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
      //   connectFunctionsEmulator(functions, '127.0.0.1', 5001);
      // }
      return functions;
    }),
    { provide: LOCALE_ID, useValue: 'es' },
  ],
};

// Register Spanish locale data so DatePipe / DecimalPipe work with 'es'
registerLocaleData(localeEs);
